import { render } from "./SidebarTabs.vue?vue&type=template&id=064ea00a"
import script from "./SidebarTabs.vue?vue&type=script&lang=js"
export * from "./SidebarTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__